import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { courseAddFlrstGuardianDl } from 'dsoapi';

const FlrstPageAcknowledgement = () => {
  const { userCourseEnrollmentId } = useParams();
  const navigate = useNavigate();
  const [agreements, setAgreements] = useState({
    q1: false,
    q2: false,
    q3: false,
    q4: false,
    q5: false,
    q6: false,
  });
  const [driverLicense, setDriverLicense] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCheckboxChange = (name) => {
    setAgreements((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all checkboxes are checked
    const allAgreed = Object.values(agreements).every((agreed) => agreed);
    if (!allAgreed) {
      setError('You must agree to all terms before proceeding.');
      return;
    }

    // Validate driver license is provided
    if (!driverLicense.trim()) {
      setError('Driver license number is required.');
      return;
    }

    setIsSubmitting(true);
    setError('');

    try {
      // Submit the guardian driver license to the API
      await courseAddFlrstGuardianDl(userCourseEnrollmentId, {
        GuardianDriverLicenseNumber: driverLicense.trim(),
      });

      // Navigate to the exam directions page after successful submission
      navigate(`/floridaexamdirections/${userCourseEnrollmentId}`);
    } catch (error) {
      console.error('Error submitting guardian driver license:', error);
      setError(
        'Failed to submit driver license information. Please try again.'
      );
      setIsSubmitting(false);
    }
  };

  return (
    <div className="ui container" style={{ marginTop: '2em' }}>
      <h1 style={{ textAlign: 'center' }}>
        <strong>State Terms and Acknowledgements</strong>
      </h1>

      <h3>
        By entering the parent or guardian's driver license number and
        confirming each item below, the Applicant & Parent/Guardian are
        acknowledging and agreeing to the following State Terms:
      </h3>

      <form onSubmit={handleSubmit}>
        {error && <div className="ui error message">{error}</div>}

        <div className="ui segment">
          <p>
            Prior to the issuance of any exam, the Parent/Guardian is required
            to electronically certify that the Applicant will be monitored and
            not assisted during the on-line exam.
          </p>
          <div className="ui checkbox">
            <input
              type="checkbox"
              id="q1"
              name="q1"
              checked={agreements.q1}
              onChange={() => handleCheckboxChange('q1')}
            />
            <label htmlFor="q1">Agree</label>
          </div>
        </div>

        <div className="ui segment">
          <p>
            Prior to the issuance of a Learner's License, the Parent/Guardian is
            required to certify to the Department that the Applicant was
            monitored during the on-line examination and that the
            Parent/Guardian was aware of and allowed the Applicant to take the
            examination on-line.
          </p>
          <div className="ui checkbox">
            <input
              type="checkbox"
              id="q2"
              name="q2"
              checked={agreements.q2}
              onChange={() => handleCheckboxChange('q2')}
            />
            <label htmlFor="q2">Agree</label>
          </div>
        </div>

        <div className="ui segment">
          <p>
            Prior to the issuance of any exam, the Parent/Guardian is required
            to electronically certify that the Applicant will be monitored and
            not assisted during the on-line exam.
          </p>
          <div className="ui checkbox">
            <input
              type="checkbox"
              id="q3"
              name="q3"
              checked={agreements.q3}
              onChange={() => handleCheckboxChange('q3')}
            />
            <label htmlFor="q3">Agree</label>
          </div>
        </div>

        <div className="ui segment">
          <p>
            Any Applicant or Parent/Guardian giving false statements regarding
            the Applicant's examination efforts is committing fraud and is
            subject to license cancellation for a period of one year in
            accordance with Section 322.22 and 322.27(1)(d), Florida Statutes.
          </p>
          <div className="ui checkbox">
            <input
              type="checkbox"
              id="q4"
              name="q4"
              checked={agreements.q4}
              onChange={() => handleCheckboxChange('q4')}
            />
            <label htmlFor="q4">Agree</label>
          </div>
        </div>

        <div className="ui segment">
          <p>
            All Applicants are subject to random selection for re-examination at
            the driver license or tax collector office prior to the issuance of
            any license. Failure to pass the random re-exam will require the
            Applicant to pass the knowledge exam prior to license issuance.
          </p>
          <div className="ui checkbox">
            <input
              type="checkbox"
              id="q5"
              name="q5"
              checked={agreements.q5}
              onChange={() => handleCheckboxChange('q5')}
            />
            <label htmlFor="q5">Agree</label>
          </div>
        </div>

        <div className="ui segment">
          <p>
            Students who do not pass the exam must pay a $20 retesting fee for
            each additional attempt.
          </p>
          <div className="ui checkbox">
            <input
              type="checkbox"
              id="q6"
              name="q6"
              checked={agreements.q6}
              onChange={() => handleCheckboxChange('q6')}
            />
            <label htmlFor="q6">Agree</label>
          </div>
        </div>

        <div className="ui segment">
          <p>
            A valid driver license number from the parent or guardian must be
            provided before the online exam can begin. Please enter this in the
            field below.
          </p>
          <div className="ui field">
            <label htmlFor="dl">Driver's License of Parent/Guardian:</label>
            <input
              type="text"
              id="dl"
              name="dl"
              value={driverLicense}
              onChange={(e) => setDriverLicense(e.target.value)}
              className="ui input"
              disabled={isSubmitting}
            />
          </div>
        </div>

        <button
          type="submit"
          className={`ui primary button ${isSubmitting ? 'loading' : ''}`}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit & Agree'}
        </button>
      </form>
    </div>
  );
};

export default FlrstPageAcknowledgement;
